module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/lightThemeImage-3b64c9ea3a39acb5ee23473129d28a9b.png";